// https://github.com/airbnb/browser-shims required by https://github.com/airbnb/javascript
// TODO: check if we need airbnb-browser-shim?
// import 'airbnb-browser-shims';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'reflect-metadata';
import { RouterProvider } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import i18nDefault from './translation/i18n';
import { onSWUpdate } from './onSWUpdate';
import { router } from './routes/sharedRoutes';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

function IndexApp() {
  return (
    <React.StrictMode>
      <I18nextProvider i18n={i18nDefault}>
        <RouterProvider router={router} />
      </I18nextProvider>
    </React.StrictMode>
  );
}

root.render(<IndexApp />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({ onUpdate: onSWUpdate });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
reportWebVitals();
